import React from 'react';
import { Link } from 'react-router-dom';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import { useScrollReveal, useCountUp } from '../hooks/useScrollReveal';
import appsCustomer from '../assets/apps-customer.jpg';
import appsTrackTrace from '../assets/apps-track-trace.jpg';

const Apps = () => {
  useScrollReveal();
  useCountUp();

  return (
    <>
      <Nav darkMode={true} />
      
      <section className="hero-dark">
        <div className="grid-bg"></div>
        <div className="hero-dark-inner">
          <div className="pill reveal in">APPS</div>
          <h1 className="reveal in">Put the counter in every pocket.</h1>
          <p className="sub reveal in">The Customer App gives constituents shipping, tracking, and payments on their phone. Track &amp; Trace gives your officers pickup, delivery, and proof of delivery on theirs.</p>
        </div>
      </section>

      <section id="customer-app">
        <div className="wrap">
          <div className="section-head reveal">
            <span className="eyebrow">Customer App</span>
            <h2>Ship, track, and pay &mdash; from one app.</h2>
            <p>The Valor Customer App puts shipping, tracking, and account management directly in constituents' hands, a streamlined mobile companion for every counter service Valor OS powers.</p>
          </div>
          <div className="app-photo reveal">
            <img src={appsCustomer} alt="Customer checking a delivery tracking app on her phone while holding a parcel" />
          </div>
          <div className="spec-grid cols-2 reveal-stagger">
            <div className="spec-card">
              <h3>Features</h3>
              <ul className="spec-list">
                <li>Streamlined process for shipping parcels</li>
                <li>Real-time tracking for peace of mind</li>
                <li>Enhanced security with OTP authentication</li>
                <li>Book and renew PO boxes without a counter visit</li>
                <li>Locate nearby service points with the in-app locator</li>
                <li>User profiles for transactions and preferences</li>
                <li>Secure in-app payment for every service</li>
                <li>Accessible, user-friendly design for all backgrounds</li>
                <li>Built-in ratings and feedback to improve service</li>
                <li>Electronic billing to cut paper waste</li>
              </ul>
            </div>
            <div className="spec-card">
              <h3>Technology</h3>
              <ul className="spec-list">
                <li>Connects directly to UPU CDS and IPS systems</li>
                <li>Open to third-party API integration</li>
                <li>Integrated with major payment gateways, including Mastercard and Visa</li>
                <li>In-app ad placements available</li>
                <li>Native support for Android and iPhone</li>
                <li>Built for speed on a fast-paced day</li>
              </ul>
              <div className="platform-pill"><span>Android</span><span>iOS</span></div>
            </div>
          </div>
        </div>
      </section>

      <section className="fog-section" id="track-trace">
        <div className="wrap">
          <div className="section-head reveal">
            <span className="eyebrow">Track &amp; Trace</span>
            <h2>Pickup, delivery, and proof &mdash; in the field.</h2>
            <p>Track &amp; Trace is Valor's field app, built for pickup, delivery, and proof of delivery, fully integrated with every Valor OS and CounterOps record.</p>
          </div>
          <div className="app-photo reveal">
            <img src={appsTrackTrace} alt="Field officer scanning a parcel barcode beside a delivery van" />
          </div>
          <div className="spec-grid cols-3 reveal-stagger">
            <div className="spec-card">
              <h3>Delivery Experience</h3>
              <ul className="spec-list">
                <li>Tracking on every event, end to end</li>
                <li>Real-time SMS and email updates to the customer</li>
                <li>Barcode scanning at every stage</li>
                <li>GPS and location integration</li>
                <li>Signature capture on delivery</li>
                <li>ID capture where required</li>
              </ul>
            </div>
            <div className="spec-card">
              <h3>Technology</h3>
              <ul className="spec-list">
                <li>Integrated with UPU IPS and IPS Light</li>
                <li>Integrated with UPU CDS</li>
                <li>Open integration with third-party APIs</li>
                <li>Integrated with e-commerce portals</li>
                <li>User-configurable for most services</li>
                <li>Address-database integration for autofill</li>
                <li>Supported on Windows, PDTs, iOS, and Android</li>
              </ul>
            </div>
            <div className="spec-card">
              <h3>Management</h3>
              <ul className="spec-list">
                <li>End-to-end tracking</li>
                <li>Full audit trails</li>
                <li>Comprehensive management reporting</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="stat-callout">
        <div className="wrap">
          <p className="lede reveal">One app for the people you serve. One app for the officers who serve them.</p>
          <div className="stats-2 reveal-stagger">
            <div className="stat"><h3 data-count="2" data-suffix="">0</h3><p>Apps, one connected record</p></div>
            <div className="stat"><h3 data-count="100" data-suffix="%">0</h3><p>UPU standards compliant</p></div>
          </div>
        </div>
      </section>

      <section id="get-started">
        <div className="wrap">
          <div className="cta-band reveal">
            <h2>See the apps on your own network.</h2>
            <p>Customer App and Track &amp; Trace, connected to Valor OS and CounterOps out of the box.</p>
            <div className="hero-ctas">
              <a href="#contact" className="btn btn-accent">Request Briefing <span className="arrow">→</span></a>
              <Link to="/valor-os" className="btn btn-outline" style={{borderColor:'rgba(255,255,255,.25)', color:'#fff'}}>Explore Valor OS <span className="arrow">→</span></Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Apps;
